export const hasMore = (list = [], total = 0) => list.length < total

export const getNextPageNo = (list = [], pageSize = 25) =>
  parseInt(list.length / pageSize, 10)

export default 0
